import type { ComponentProps } from 'react';
import type { RaceEventStatus, RaceFormat, ScoringMethod } from './types';
import type { Badge } from '../ui';

/** A human label for each competition structure. */
export function formatLabel(format: RaceFormat): string {
  switch (format) {
    case 'SingleElimination':
      return 'Single elimination';
    case 'DoubleElimination':
      return 'Double elimination';
    case 'HeatsThenFinal':
      return 'Heats + final';
    case 'TimeTrial':
      return 'Time trial';
    default:
      return format;
  }
}

/** A human label for each scoring metric. */
export function scoringMethodLabel(method: ScoringMethod): string {
  switch (method) {
    case 'HeadToHeadTime':
      return 'Fastest time';
    case 'DialInHandicap':
      return 'Dial-in handicap';
    case 'MostLapsThenTime':
      return 'Most laps, then time';
    default:
      return method;
  }
}

/** A human label for each lifecycle state. */
export function statusLabel(status: RaceEventStatus): string {
  switch (status) {
    case 'InProgress':
      return 'In progress';
    default:
      return status;
  }
}

/** The badge tone that matches a lifecycle state. */
export function statusTone(status: RaceEventStatus): ComponentProps<typeof Badge>['tone'] {
  switch (status) {
    case 'Open':
      return 'accent';
    case 'InProgress':
      return 'live';
    case 'Completed':
      return 'success';
    case 'Cancelled':
      return 'danger';
    default:
      return 'neutral';
  }
}

/** Formats a millisecond elapsed time as seconds, for example `12.345s`. */
export function formatElapsed(elapsedMs: number | null | undefined): string {
  if (elapsedMs === null || elapsedMs === undefined) {
    return '—';
  }

  return `${(elapsedMs / 1000).toFixed(3)}s`;
}
